import { createI18n } from '@geenius/i18n/solidjs-css'
import { pluralizeNotifications, translateNotifications } from '@geenius/notifications/shared'

type NotificationParams = Record<string, string | number>

function buildPluralKey(key: string, count: number): string {
  if (count === 0) {
    return `${key}_zero`
  }

  if (count === 1) {
    return `${key}_one`
  }

  return `${key}_other`
}

export function createNotificationCopy(): {
  t: (key: string, params?: NotificationParams) => string
  plural: (key: string, count: number, params?: NotificationParams) => string
} {
  let providerTranslator: ((key: string, params?: NotificationParams) => string) | null = null

  try {
    providerTranslator = createI18n().t
  } catch {
    providerTranslator = null
  }

  const translateWithProvider = (
    key: string,
    params?: NotificationParams,
  ): string | null => {
    if (!providerTranslator) {
      return null
    }

    const translated = providerTranslator(key, params)
    return translated !== key ? translated : null
  }

  return {
    t: (key: string, params?: NotificationParams) => {
      return translateWithProvider(key, params) ?? translateNotifications(key, params)
    },
    plural: (key: string, count: number, params?: NotificationParams) => {
      const translatedPlural = translateWithProvider(buildPluralKey(key, count), {
        count,
        ...params,
      })

      if (translatedPlural) {
        return translatedPlural
      }

      return pluralizeNotifications(key, count, params)
    },
  }
}
